import { openBlock, createBlock, mergeProps, createSlots, withCtx, renderSlot } from "vue";
import { VARIANTS_ENUMS } from "./constants.mjs";
import FhDropdownBaseItem from "../FhDropdownBaseItem/FhDropdownBaseItem.mjs";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhDropdownItem",
  props: {
    prefixIcon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: VARIANTS_ENUMS.DEFAULT,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    }
  },
  emits: ["select"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const handleSelect = (event) => {
      if (!props.disabled) {
        emit("select", event);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhDropdownBaseItem, mergeProps({
        prefixIcon: props.prefixIcon,
        disabled: props.disabled,
        variant: props.variant,
        onSelect: handleSelect
      }, _ctx.$attrs), createSlots({
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        _ctx.$slots["description-inline"] ? {
          name: "description-inline",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "description-inline")
          ]),
          key: "0"
        } : void 0,
        _ctx.$slots["description-block"] ? {
          name: "description-block",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "description-block")
          ]),
          key: "1"
        } : void 0
      ]), 1040, ["prefixIcon", "disabled", "variant"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FhDropdownItem.mjs.map
